import { OkrFrontPage } from './../../shared/interfaces/okr-front-page';
import { OkrProgressModelComponent } from './okr-progress-model/okr-progress-model.component';
import { OkrKeyResult } from './../../shared/interfaces/okr-key-result.interface';
import { Okr } from './../../shared/interfaces/okr.interface';
import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { BaseClass } from 'src/app/shared/classes/base';
import {
  FilterModel,
  FilterItem,
  AttributeTypeEnum,
  AttributeFilter,
} from 'src/app/shared/modals/filters/models/filter-models';
import {
  LoadingController,
  ToastController,
  ModalController,
} from '@ionic/angular';
import { OkrService } from 'src/app/okr/okr.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { UntypedFormBuilder } from '@angular/forms';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { OkrObjective } from 'src/app/shared/interfaces/okr-objective.interface';
import * as moment from 'moment';
import { AttributeItem } from 'src/app/shared/interfaces/attribute-item';
import { UserItem, AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-okr',
  templateUrl: './okr-progress.component.html',
  styleUrls: ['./okr-progress.component.scss'],
})
export class OkrProgressComponent extends BaseClass
  implements OnDestroy, OnInit {
  // public filters: FilterModel[] = [];
  // public attributes: FilterItem[];
  public okrCount: number = 0;
  public attributeId: number = null;
  public okr: OkrFrontPage;

  @Output() reloadProgresses: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private _loadingController: LoadingController,
    private _okrService: OkrService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    _toastController: ToastController,
    _translationService: TranslationService,
    private _formBuilder: UntypedFormBuilder,
    private _backEndService: BackendService,
    private _authService: AuthService,
    private modalController: ModalController
  ) {
    super(_toastController, _translationService);
  }

  ngOnInit() {
    this.loadOkrs();
  }

  public async loadOkrs(AttributeId?): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();
    this._okrService.getObjectivesFrontPage(AttributeId).subscribe(
      (response) => {
        this.okr = response.data;
        this.okrCount = this.okr.objectives.length;
        if (AttributeId === undefined &&  this.okr.visibleAttributes.length > 0) {
          this.attributeId = this.okr.visibleAttributes[0].id;
        }
        loading.dismiss();
      },
      (error) => {
        loading.dismiss();
        this.notifyError(error);
      }
    );
    loading.dismiss();
  }

  public getToolTipText() {
    return this._translationService.getTranslation(
      'okr.toolTipDescription'
    );
  }

  public getStatusColor(deadline: Date): string {
    const momentDueDate = moment(deadline).startOf('day');
    const momentToday = moment().startOf('day');
    const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();
    if (diff <= 10 && diff > 3) {
      return 'warning';
    } else if (diff > 0 && diff <= 3) {
      return 'danger';
    } else {
      return 'primary';
    }
  }

  public getProgressBarColor(deadline: Date, color: string): boolean {
    const statusColor = this.getStatusColor(deadline);
    return color === statusColor ? true : false;
  }

  public getProgressBarLength(currentProgress: number) {
    return { width: currentProgress + '%' };
  }

  public async viewGoalModal(keyResult: OkrKeyResult) {
    const goalModal = await this._createGoalModal(keyResult.id);

    goalModal.onDidDismiss().then((dismissEvent) => {
      if (dismissEvent.data) this.reloadProgresses.emit(true);
    });

    goalModal.present();
  }

  private async _createGoalModal(keyResultId: number) {
    return await this.modalController.create({
      component: OkrProgressModelComponent,
      cssClass: 'view-goals-modal-style',
      componentProps: {
        keyResultId: keyResultId
      },
    });
  }

  ngOnDestroy() {}
}
